import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Calendar } from 'iconsax-react';
import { listStateKey, useRememberedFilter } from './listState';

/*
 * Intervalli (date, importi) delle liste: al posto dei campi "dal/al" sulla riga della
 * ricerca, che la mandavano a capo, un pulsante con l'icona apre una finestra con gli
 * intervalli. Le modifiche valgono solo con "Applica".
 *
 *   ranges: [{ key, label, type: 'date' | 'number' }]
 *   value:  { [key]: { da, a } }   (chiave assente o vuota = nessun limite)
 *   onApply(nuovoValue)
 *
 * Il pulsante si evidenzia come un chip attivo e dice quanti intervalli sono impostati.
 */
const vuoto = (range) => !range || (!range.da && !range.a);

export const RangeFilterButton = ({ label = 'Periodo', title, ranges, value, onApply }) => {
	const [show, setShow] = useState(false);
	const [draft, setDraft] = useState({});
	useRememberedFilter(listStateKey('intervalli', label), value, onApply);

	const attivi = ranges.filter((r) => !vuoto(value?.[r.key])).length;

	const apri = () => {
		setDraft(value || {});
		setShow(true);
	};

	const aggiorna = (key, campo, v) =>
		setDraft((prec) => ({ ...prec, [key]: { ...(prec[key] || {}), [campo]: v || undefined } }));

	const applica = (nuovo) => {
		const pulito = {};
		ranges.forEach((r) => {
			if (!vuoto(nuovo[r.key])) pulito[r.key] = nuovo[r.key];
		});
		onApply(pulito);
		setShow(false);
	};

	return (
		<>
			<button
				type="button"
				className={`sid-chip sid-range-btn${attivi ? ' is-active' : ''}`}
				onClick={apri}
				aria-haspopup="dialog"
			>
				<Calendar size={16} />
				{label}
				{attivi > 0 && <span className="sid-range-btn__count">{attivi}</span>}
			</button>

			<Modal show={show} onHide={() => setShow(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{title || label}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ranges.map((r) => (
						<Form.Group key={r.key} className="sid-range-modal__group">
							<Form.Label className="sid-range-modal__label">{r.label}</Form.Label>
							<div className="sid-range-modal__row">
								<Form.Label className="sid-range-modal__sub" htmlFor={`range-${r.key}-da`}>dal</Form.Label>
								<Form.Control
									id={`range-${r.key}-da`}
									type={r.type || 'date'}
									value={draft[r.key]?.da || ''}
									onChange={(e) => aggiorna(r.key, 'da', e.target.value)}
								/>
								<Form.Label className="sid-range-modal__sub" htmlFor={`range-${r.key}-a`}>al</Form.Label>
								<Form.Control
									id={`range-${r.key}-a`}
									type={r.type || 'date'}
									value={draft[r.key]?.a || ''}
									onChange={(e) => aggiorna(r.key, 'a', e.target.value)}
								/>
							</div>
						</Form.Group>
					))}
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => applica({})}>
						Azzera
					</Button>
					<Button className="btn btn-primary btn-add" onClick={() => applica(draft)}>
						Applica
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default RangeFilterButton;
